<template>
  <a-card style="width: 300px" v-if="$store.state.data_alys_cmds.execResult['status']">
    <p>{{ $store.state.data_alys_cmds.execResult['status'] }}</p>
    <p>{{ $store.state.data_alys_cmds.execResult['description'] }}</p>
    <p>{{ $store.state.data_alys_cmds.execResult['result'] }}</p>
  </a-card>
</template>